module.exports = __webpack_public_path__ + "img/nav-sentosa-orange.d4a418fd.svg";